import { LocaleType } from "./index";
const enUS: LocaleType = {
  chat: {
    title: "Online Service",
    historyMsg: "The above is history message.",
    moreHistory: "View more history messages",
    noMoreHistory: "No more messages",
    wholeHistory: "The above is history record",
    canceledLineUp: "You have left the queue.",
    cancelLineUp: "Cancel queuing",
    newMessageTips: "{0} new messages",
    questionListTitle:
      "Welcome to Bambu Lab Customer Support. For any assistance, please click on the list below to find the relevant agent.",
    questionSolved: "Was your issue resolved after this service?",
    solved: "Resolved",
    unSolved: "Unresolved",
    satisfyTitle:
      "Please rate the service on your experience. (1 = Very Dissatisfied, 5 = Very Satisfied)",
    satisfyPlaceholder:
      "Kindly share the feedback for your better experience and our improvement.",
    withdrawing: "Recalling",
    withdraw: "Recall",
    quotedMessage: "Quote",
    copy: "Copy",
    video: "Video",
    image: "Image",
    file: "File",
    reply: "Reply",
    expandText: "Expand",
    collapseText: "Collapse",
    iHaveRedrawMsg: "You recalled a message.",
    othersHaveRedrawMsg: "The other party has withdrawn the message",
    quotedHaveRedrawMsg: "The reference message has been withdrawn",
    stopServiceTips:
      "Today's manual service will end at ${0}. Thank you for your patience. You can contact us again during the manual service time the next day or submit a work order to get in touch with us.",
    AISuspended: "Bambu AI has been suspended",
    AIProvided:
      "The content is generated by Bambu AI and is for reference purposes only.",
    isHelpful: "Was this information helpful to you?",
    hasIMSession: "You're already in the chat. Just type to continue chatting.",
  },
  aiFeedback: {
    satisfyTitle: "Did my answer resolve your issue?",
    satisfyPlaceholder:
      "Kindly share the feedback for your better experience and our improvement.",
    satisfyLiked:
      "Thank you for your feedback! We will make improvements to provide a better experience.",
    satisfyDislike: "Unresolved",
    satisfyLike: "Resolved",
    satisfyClose: "Close",
    satisfySubmit: "Submit",
    satisfyCancel: "Cancel",
    satisfyDislikeOptionLabel: "Issue",
    satisfyKnowledgeReasonLabel: "Reason ID",
    "2000": "No help",
    "2001": "Knowledge is outdated",
    "2002": "Problem understanding error",
    "2003": "Fact error",
    "2004": "Answer is not accurate",
    "2005": "Content harmful/unhealthy",
    "2006": "Inconsistent previous and subsequent replies",
    "10": "The response time is too long",
    "20": "The answer was unrelated",
    "30": "The answer was not detailed or accurate enough",
    "40": "Unable to find the answer",
    "50": "Wiki article is incorrect",
    "1000": "Other",
    desc1:
      "Your feedback is valuable to us—share your experience to help us refine and improve our service in future updates.",
    desc2: "",
    feedbackTypeLabel: "Reason",
    /** Radio group title when dislike feedback is read-only (after refresh) */
    feedbackTypeLabelReadOnly: "Unresolved reason:",
    feedbackPlaceholder: "Please input your feedback and suggestions",
    feedbackLabel: "Advice",
    thanksFeedback:
      "Thanks for your feedback! We will make improvements to provide a better experience.",
    submit: "Submit",
    thanksAIFeedback:
      "Thanks for your feedback! We will make improvements to provide a better Bambu AI experience.",
  },
  aiProtocolModal: {
    title: "Welcome to Bambu Robot",
    protocolContent: "Dear User :  ",
    protocolContent1:
      "Your interaction with this service implies your acceptance of the <1>Terms of Use</1>. We ensure the protection of your privacy with our <3>Privacy Policy</3>.  Click 'Continue' for interaction with our Bambu AI.",
    protocolContent2:
      "Please read the following disclaimer before proceeding: Responses are generated by Bambu AI Beta, and errors or omissions may occur. Accuracy, completeness, and normativity are not guaranteed, and information should be verified before use. The views expressed do not represent those of the service provider. Bambu AI Beta has limitations, and efforts are ongoing to enhance its accuracy.",
    continue: "Continue",
    tips: "",
  },
  resetUrlModal: {
    showAgainBtn: "Hide for 7 days",
    goNow: "Switch",
    toCNDesc:
      "We recommend visiting the domestic site for the fastest experience.",
    toENDesc:
      "We recommend visiting the international site for the fastest experience.",
  },
  systemMsg: {
    title: "Live Chat | Bambu Lab",
    satisfyComment: "Submit successfully.",
    msgWithDrawn: "You recalled a message.",
    msgWithDrawnByOthers: "The other party's message has been withdrawn",
    reEditExpired: "Re-edit period has expired.",
    chatEnd: "You have ended the chat.",
    messageLoading: "Loading...",
    unknownErrorTips: "Network error, please try again",
    noUserInfo: "Login error. Please try again.",
    messageEnded: "The chat has ended.",
    messageTimeout: "Chat timeout.",
    lineUpTimeout: "Queue timeout.",
    dataRecovery: "Loading...",
    refreshPageTips: "Error loading, please reload the page and try again.",
    currentTimeNotService:
      "It’s currently outside our working hours. Please contact us again during business hours or submit a ticket for assistance.",
  },
  button: {
    submit: "Submit",
    endMessage: "End chat",
    confirm: "Yes",
    reEdit: "Edit",
  },
  chatBar: {
    sendButton: "Send",
    inputPlaceholder: "Please choose the issue type",
    confirmEndMessage: "Are you sure to end the session?",
    confirmExit: "Are you sure to log out?",
    tips: "Tips",
  },
  chatBox: {
    expendButtonTitle: "Quick question",
    autoCompletePlaceholder: "Fuzzy keyword search",
  },
  chatInput: {
    sendButton: "Send",
    inputPlaceholder: "Please type the message",
    selectEmoji: "Choose the emoji",
    recentlyUse: "Recently used",
    connecting: "Connecting...",
    networkError: "Network error.",
    networkLost: "The chat is disconnected. Click ",
    processError:
      "The agent is unavailable now, kindly contact the customer support via <a href='${0}' target='_blank'>ticket</a>",
    resetCreateChat: "here ",
    networkLostEndText: "to restart.",
    fileLimitTips: "The size is limited to ${0}MB.",
    sendConfirm: "Are you sure to send it?",
    inputPlaceholderDisabled: "Please choose the issue type",
  },
  footerTabBar: {
    generalInquiries: "General Inquiries",
    selfService: "Self Service",
    popularTags: "Popular Tags",
    wikiArticles: "Wiki Articles",
    inAppTips: "Please open in the Handy app",
    IMService: "Live Chat",
  },
  common: {
    sendError: "Failure to send, network error",
    loading: "Loading...",
    requestTimeout: "The request has timed out. Please refresh and try again",
  },
  error: {
    pageError: "System error.",
    errorVisible: "Ops, error.",
    reload: "Reloading...",
    loginError: "Login failed.",
    loginLoading: "Logging in...",
  },
  privacyPolicy: {
    title: "Welcome to Online Customer Service",
    subTitle:
      "To ensure service quality, your request information will be recorded. We protect your privacy through our",
    linkName: "Privacy Policy",
    confirmTips: "to ensure your privacy is protected.",
    readAndConfirm: "I have read and agree to the",
    usePolicy: "Terms of Use",
    and: "and",
    privatePolicy: "Privacy Agreement",
    enterChat: "Enter Chat",
  },
  tips: {
    copySuccess: "Copied successfully",
    copyFileSuccess: "Copied, please visit the link via the browser.",
  },
  riskMsg: {
    forbidden: "**********",
    content: "*************",
    copySuccess: "Copied successfully",
  },
  sidebar: {
    hello: "Hello",
    desc: "We're here to help you",
  },
  header: {
    robotDesc: "Customer Service Robot",
    robot: "Bambu Lab",
  },
  carouselImageList: {
    title1: "Visit Store",
    boxIssueTitle: "Machine Issue",
    logisticsIssueTitle: "Logistics Issue",
  },
  categoryList: {
    error: "No content available",
  },
  issueType: {
    missionItems: {
      templateName: "Missing Items",
      attachmentTips: [
        "Please provide order number and package photos",
        "Please provide package label photos",
        "Please provide photos of missing items",
      ],
    },
    receivedTheWrongItem: {
      templateName: "Received Wrong Item",
      attachmentTips: [
        "Please provide photos of received items",
        "Please provide photos of received items",
      ],
    },
    shippingOrPackaging: {
      templateName: "Shipping or Packaging",
      attachmentTips: [
        "Please provide photos of damaged packaging",
        "Please provide photos of damaged product",
        "Please provide tracking number",
      ],
      attachmentTipText: "Please provide relevant photos",
      children: [
        "Printer Damaged",
        "AMS Damaged",
        "Accessory Damaged",
        "Packaging damaged but product intact",
        "Other",
      ],
    },
    factoryDamage: {
      templateName: "Factory Damage",
      attachmentTips: [
        "Please provide product serial number photo",
        "Please provide damaged part photo",
        "Please provide intact packaging photo",
      ],
    },
    manufacturingIssue: {
      attachmentTips: [
        "Please provide product serial number photo",
        "Please provide problem photos or videos",
        "Please describe the issue in detail",
      ],
    },
    lostPackage: {
      templateName: "Lost Package",
      childLabelTips: "Please select the reason for loss",
      children: [
        "Package not received",
        "Package stolen",
        "Lost by courier company",
        "Other",
      ],
      attachmentTips: "Please provide relevant proof",
    },
    noShippingMovementForDays: "No shipping update for days",
    shippedToTheWrongAddress: {
      templateName: "Shipped to Wrong Address",
      children: ["Incorrect address entry", "System address error", "Other"],
    },
    packageWasReturnedToSenderOrCanceled: "Package returned or canceled",
    carrierServiceComplaint: "Carrier service complaint",
    other: "Other",
    testMachineOptions: [
      "No, I have not tested the printer/AMS",
      "Yes, it works properly",
      "Yes, but it malfunctions",
    ],
  },
  collectOrderInfo: {
    title: "Please provide your order number and the email for verification",
    orderNumPlaceholder: "Please input",
    emailPlaceholder: "Please input",
    submit: "Submit",
    email: "E-mail",
    orderNum: "Order No.",
    orderNumMessage: "Please input Order No.",
    orderNumMessageTip: "The format is GB/EN/AU/UK/US/CA/JPxxx",
  },
  uDeskTicker: {
    imgFormatError: "You can only upload JPG/PNG file!",
    imgSizeError: "Image must smaller than 20MB!",
    submit: "Submit",
    cancelText: "Cancel",
    issueType: "Cause of the issue",
    email: "E-mail",
    emailPlaceholder: "Account email",
    orderNum: "Order No.",
    orderNumPlaceholder: "Order No.",
    UploadText: "+ Upload",
    model: "Printer Model(or Product)",
    address: "Address",
    addressOptions: {
      "1": "Same as the order address",
      "2": "Need to change the address",
    },
    changeAddress: "address",
    comment: "Please provide specific details of the situation",
    commentTips: "Please provide a brief description of your issue.",
    testMachine: "Have you tested the printer/AMS?",
    orderNumTips:
      "(Please add # in front of the order number if inapplicable.)",
    orderNumMessage: "Please input Order No.",
    informationNotMatch:
      "Information does not match, please verify and try again",
    attachment: "Attachment",
    other: "Other",
    orderNumMessageTip: "How to get Order ID ?",
    noRecord: "No records",
  },
  feedback: {
    reasonOptions: {
      "1": "No specific questions to ask.",
      "2": "Answers are not accurate enough.",
      "3": "The process is too complicated.",
      "4": "Other",
    },
    submitReply: "Thanks for your feedback!",
    title1:
      "Your feedback is valuable to us—share your experience to help us refine and improve our service in future updates.",
    title2: "",
    feedbackTypePlaceholder: "Please select",
    feedbackTypeLabel: "Reason",
    feedbackPlaceholder: "Please input your feedback and suggestions",
    feedbackLabel: "Advice",
    submit: "Submit",
  },
  selectCategory: {
    notFound:
      "Sorry, I can't find relevant questions and answers. Please submit a ticket for further assistance.",
    title: "Please select your question type to continue.",
    contactUs: "None of these apply to my situation. I'd like to",
    submitTicket: "submit a ticket",
  },
  selectQuestion: {
    title: "Click to get the answer.",
    contactUs: "None of these apply to my situation. I'd like to",
    submitTicket: "submit a ticket",
    more: "More",
    less: "Less",
  },
  selectHotAIQuestion: {
    tryAgain: "Please try again later",
    replying:
      "Currently there is content that Bambu AI is replying, please try again later",
    hotTopics: "Hot Topics",
    AIModeStartTips: "Please activate Bambu AI mode",
    hotThinking: "Are you trying to ask about...?",
    printerTips: "Having trouble preparing to print? Let me help you out!",
    bindingPrinterTips: (printerModel: string) => {
      return `What issue did you encounter while binding ${printerModel}?`;
    },

    bindingPrinterTipsNoPrinter:
      "What issue did you encounter while binding the printer?",
  },
  firstAIReply:
    "For additional support：<ul><li>Go to the official flagship store of Bambu Lab（<a class='message-link' href='https://mall.jd.com/index-12045041.html' target='_blank'>JD</a>丨<a class='message-link' href='https://bambulab.tmall.com' target='_blank'>Tmall</a>丨Pinduoduo丨TikTok）to contact customer service</li><li>Click here to contact <a class='message-link' href='/im?from=2' target='_blank'>online technical support</a> (Online time: 9:00-21:00; Holidays: 9:00-18:00)</li><li>Click here to submit a <a class='message-link' href='https://bambulab.cn/zh-cn/my/support/tickets/create?from=2' target='_blank'>technical ticket</a></li><li>Call the service hotline <b>400 680 0166</b> (Online time: 9:00-12:30, 14:00-18:00 on weekdays)</li><li>Click here to submit a <a class='message-link' href='https://makerworld.com.cn/zh/my/support/tickets/create?from=2' target='_blank'>MakerWorld ticket</a></li></ul>",
  firstAIReplyOversea:
    "For additional support, our dedicated support team is here to assist you:<ul><li>For product, order-related and general inquiries, you can contact us via <a class='message-link' href='/im?from=2' target='_blank'> Live Chat </a>(24/7).</li><li>For accessories/filament issues, shipping/delivery issues, please submit a <a class='message-link' href='https://bambulab.com/my/support/general-inquiry?from=2' target='_blank'>General Ticket</a>.</li><li>For printer/AMS performance matters, <a class='message-link' href='https://bambulab.com/my/support/tickets/create?from=2' target='_blank'> Technical Tickets </a> ensure more professional support. </li><li>For issues concerning MakerWorld, please submit a <a class='message-link' href='https://makerworld.com/en/my/support/tickets/create?from=2' target='_blank'> MakerWorld Support Ticket</a>.</li>",
};

export default enUS;
